import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Sofa = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <line
          x1='6.25'
          y1='17.5347'
          x2='6.25'
          y2='19.0347'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <line
          x1='17.75'
          y1='17.5347'
          x2='17.75'
          y2='19.0347'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <path
          d='M5 9.28467V7.28467C5 5.62781 6.34315 4.28467 8 4.28467H16.5C17.8807 4.28467 19 5.40396 19 6.78467V9.28467'
          stroke='currentColor'
          strokeWidth='1.5'
        />
        <path
          d='M20.5 16.7847H3.5C2.94772 16.7847 2.5 16.337 2.5 15.7847V10.7847C2.5 10.1552 2.79639 9.56238 3.3 9.18467C4.01111 8.65133 4.98889 8.65133 5.7 9.18467C6.20361 9.56238 6.5 10.1552 6.5 10.7847V12.2847H17.5V10.7847C17.5 10.1552 17.7964 9.56238 18.3 9.18467C19.0111 8.65133 19.9889 8.65133 20.7 9.18467C21.2036 9.56238 21.5 10.1552 21.5 10.7847V15.7847C21.5 16.337 21.0523 16.7847 20.5 16.7847Z'
          stroke='currentColor'
          strokeWidth='1.5'
        />
      </>
    ) : (
      <>
        <line
          x1='6.25'
          y1='17.542'
          x2='6.25'
          y2='19.042'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <line
          x1='17.75'
          y1='17.542'
          x2='17.75'
          y2='19.042'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <path
          d='M5 9.29199V7.29199C5 5.63514 6.34315 4.29199 8 4.29199H16.5C17.8807 4.29199 19 5.41128 19 6.79199V9.29199'
          stroke='currentColor'
          strokeWidth='1.5'
        />
        <path
          d='M20.5 16.792H3.5C2.94772 16.792 2.5 16.3443 2.5 15.792V10.792C2.5 10.1625 2.79639 9.5697 3.3 9.19199C4.01111 8.65866 4.98889 8.65866 5.7 9.19199C6.20361 9.5697 6.5 10.1625 6.5 10.792V12.292H17.5V10.792C17.5 10.1625 17.7964 9.5697 18.3 9.19199C19.0111 8.65866 19.9889 8.65866 20.7 9.19199C21.2036 9.5697 21.5 10.1625 21.5 10.792V15.792C21.5 16.3443 21.0523 16.792 20.5 16.792Z'
          fill='currentColor'
          stroke='currentColor'
          strokeWidth='1.5'
        />
      </>
    )}
  </IconBase>
);
